// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

html {
    height: 100%;
}
body {
    height: 100%;
    background: #000000 !important;
    color: rgba(255,255,255,.5) !important;
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: "TeleNeoWeb";
    font-size: 16px;
}

.ui.selection.visible.dropdown>.text:not(.default) {
    color: rgba(255,255,255,.4) !important;
}
.ui.active.search.dropdown input.search:focus+.text {
    color: rgba(255,255,255,.4) !important;
}


.ui.selection.dropdown {
    background-color: rgba(0,0,0,.6);
    border: solid 1px rgba(255,255,255,.2);
    color: rgba(255,255,255,.6) !important;
    line-height: 1.1em !important;
}
.ui.selection.dropdown:hover {
    border-color: rgba(255,255,255,.4);
    color: rgba(255,255,255,.75) !important;
}
.ui.search.dropdown>.text {
    color: inherit !important;
}
.ui.dropdown .menu {
    background-color: rgba(0,0,0,.6);
    color: rgba(255,255,255,.7) !important;
    font-weight: normal !important;
}
.ui.selection.active.dropdown .menu {
    border-top: solid 1px rgba(255,255,255,.05) !important;
}
.ui.dropdown .menu .selected.item,
.ui.dropdown.selected,
.ui.menu .ui.dropdown .menu>.selected.item {
    background: rgba(42,50,66,1) !important;
    border: none;
    color: rgba(255,255,255,0.75) !important;
}
.ui.dropdown .menu>.item,
.ui.menu .ui.dropdown .menu>.item {
    background: rgba(0,0,0,.7) !important;
    border: none;
    color: rgba(255,255,255,0.4) !important;
}
.ui.dropdown .menu>.item:hover,
.ui.menu .ui.dropdown .menu>.item:hover,
.ui.dropdown .menu .selected.item:hover {
    background-color: rgba(71,82,102,1) !important;
    color: rgba(255,255,255,0.9) !important;
}
.ui.menu .ui.dropdown .menu>.active.item,
.ui.dropdown .menu .active.item {
    font-weight: normal !important;
}

.ui.selection.dropdown .menu>.item {
    border: none;
}

.yamlDiv {
    margin-bottom: 0px;
}

/* New */


h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: 'TeleNeoWeb';
    margin-top: 0;
    margin-bottom: 0.5em;
    color: white;
    font-weight: 500;
}

.otp-registration-link {
    color: #93E019;
    background-color: transparent;
    border: none;
    display: inline;
    cursor: pointer;
}

.otp-registration-link:hover {
    color: #FFF;
}

.title {
    text-align: center;
    font-size: 18px;
    width: 100%;
    vertical-align: middle;
}

.side-nav-list {
    background-color: #000000;
    overflow: auto;
    overflow-x: hidden;
    height: calc(100vh - 52px);
}

.side-nav-list::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.side-nav-list{
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
  
    &::-webkit-scrollbar {
      width: 1px;
    }
  
    &::-webkit-scrollbar-track {
      background: transparent;
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
  }


#mex-side-nav .MuiPaper-elevation4{
    box-shadow: none !important;
}

#mex-side-nav .MuiDrawer-paperAnchorDockedLeft{
    border-right: none !important;
}

/* semanctic step */

.round_panel .steps {
    border: 1px solid hsla(0,0%,100%,.2);
}
.round_panel .step, .round_panel .step:after {
    background-color: #202125 !important;
    border: 1px solid #929395;
    color: #929395;
}

.round_panel .step .content .description, .round_panel .step .content .title {
    color:#929395;
}

.round_panel .step.active .content .description, .round_panel .step.active .content .title {
    color:#FFF;
}

.round_panel .steps .step, .round_panel .steps .step.active {
    border-right: 1px solid hsla(0,0%,100%,.2);
}

.round_panel .steps .step:after {
    border-right: 1px solid hsla(0,0%,100%,.2);
    border-bottom: 1px solid hsla(0,0%,100%,.2);
}

.round_panel .step.active, .round_panel .step.active:after {
    background-color: #f080ba !important;
}

.mex-card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #2c2d34;
    background-clip: border-box;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

/* Legend Role Marker */
.markBox .mark {
    color:#FFF;
    margin-right: 25px;
    padding: 2px 5px 2px 5px;
    font-size: 14px;
    font-weight: 900;
    border-radius: 5px;
}

.markBox .mark.markA.markS {
/*    background-color: rgba(136,221,0,.8); */
      background-color: rgba(226, 0, 116, 1);
}
.markBox .mark.markD.markM {
    background-color: rgba(255, 247, 2, 0.7);
}
.markBox .mark.markD.markC {
    background-color: rgba(255, 247, 2, 0.5);
}
.markBox .mark.markD.markV {
    background-color: rgba(255, 247, 2, 0.3);
}
.markBox .mark.markO.markM {
    background-color: rgba(204, 236, 255, 0.7);
}
.markBox .mark.markO.markC {
    background-color: rgba(204, 236, 255, 0.5);
}
.markBox .mark.markO.markV {
    background-color: rgba(204, 236, 255, 0.3);
}
/* Legend Role Marker */

/* Reg Map */
.panel_worldmap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: solid 0 rgba(255,255,255,.125);
    background-color: rgba(0,0,0,.2);
}
.panel_worldmap > div{
    height: 100%;
}
/* Reg Map */

/* Main Header Toolbar */
.MuiToolbar-regular {
    min-height: 55px !important;
}

.MuiToolbar-root>label, .MuiToolbar-root>button, .MuiToolbar-root>button.ui.button {
    margin-right:20px;
}
/* Main Header Toolbar */
`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,sCAAsC;IACtC,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;;AAGA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,sCAAsC;IACtC,6BAA6B;AACjC;AACA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,8BAA8B;AAClC;AACA;IACI,sDAAsD;AAC1D;AACA;;;IAGI,uCAAuC;IACvC,YAAY;IACZ,wCAAwC;AAC5C;AACA;;IAEI,qCAAqC;IACrC,YAAY;IACZ,uCAAuC;AAC3C;AACA;;;IAGI,8CAA8C;IAC9C,uCAAuC;AAC3C;AACA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,QAAQ;;;AAGR;;;;;;IAMI,yBAAyB;IACzB,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa,GAAG,sBAAsB;AAC1C;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;;IAExC;MACE,UAAU;IACZ;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,6BAA6B;IAC/B;EACF;;;AAGF;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA,mBAAmB;;AAEnB;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAElB,aAAa;IAEb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;AACA,6CAA6C;MACvC,sCAAsC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA,uBAAuB;;AAEvB,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sCAAsC;IACtC,gCAAgC;AACpC;AACA;IACI,YAAY;AAChB;AACA,YAAY;;AAEZ,wBAAwB;AACxB;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;AACA,wBAAwB","sourcesContent":["/**\n * Copyright 2022 MobiledgeX, Inc\n *\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\nhtml {\n    height: 100%;\n}\nbody {\n    height: 100%;\n    background: #000000 !important;\n    color: rgba(255,255,255,.5) !important;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    font-family: \"TeleNeoWeb\";\n    font-size: 16px;\n}\n\n.ui.selection.visible.dropdown>.text:not(.default) {\n    color: rgba(255,255,255,.4) !important;\n}\n.ui.active.search.dropdown input.search:focus+.text {\n    color: rgba(255,255,255,.4) !important;\n}\n\n\n.ui.selection.dropdown {\n    background-color: rgba(0,0,0,.6);\n    border: solid 1px rgba(255,255,255,.2);\n    color: rgba(255,255,255,.6) !important;\n    line-height: 1.1em !important;\n}\n.ui.selection.dropdown:hover {\n    border-color: rgba(255,255,255,.4);\n    color: rgba(255,255,255,.75) !important;\n}\n.ui.search.dropdown>.text {\n    color: inherit !important;\n}\n.ui.dropdown .menu {\n    background-color: rgba(0,0,0,.6);\n    color: rgba(255,255,255,.7) !important;\n    font-weight: normal !important;\n}\n.ui.selection.active.dropdown .menu {\n    border-top: solid 1px rgba(255,255,255,.05) !important;\n}\n.ui.dropdown .menu .selected.item,\n.ui.dropdown.selected,\n.ui.menu .ui.dropdown .menu>.selected.item {\n    background: rgba(42,50,66,1) !important;\n    border: none;\n    color: rgba(255,255,255,0.75) !important;\n}\n.ui.dropdown .menu>.item,\n.ui.menu .ui.dropdown .menu>.item {\n    background: rgba(0,0,0,.7) !important;\n    border: none;\n    color: rgba(255,255,255,0.4) !important;\n}\n.ui.dropdown .menu>.item:hover,\n.ui.menu .ui.dropdown .menu>.item:hover,\n.ui.dropdown .menu .selected.item:hover {\n    background-color: rgba(71,82,102,1) !important;\n    color: rgba(255,255,255,0.9) !important;\n}\n.ui.menu .ui.dropdown .menu>.active.item,\n.ui.dropdown .menu .active.item {\n    font-weight: normal !important;\n}\n\n.ui.selection.dropdown .menu>.item {\n    border: none;\n}\n\n.yamlDiv {\n    margin-bottom: 0px;\n}\n\n/* New */\n\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: 'TeleNeoWeb';\n    margin-top: 0;\n    margin-bottom: 0.5em;\n    color: white;\n    font-weight: 500;\n}\n\n.otp-registration-link {\n    color: #93E019;\n    background-color: transparent;\n    border: none;\n    display: inline;\n    cursor: pointer;\n}\n\n.otp-registration-link:hover {\n    color: #FFF;\n}\n\n.title {\n    text-align: center;\n    font-size: 18px;\n    width: 100%;\n    vertical-align: middle;\n}\n\n.side-nav-list {\n    background-color: #000000;\n    overflow: auto;\n    overflow-x: hidden;\n    height: calc(100vh - 52px);\n}\n\n.side-nav-list::-webkit-scrollbar { \n    display: none;  /* Safari and Chrome */\n}\n\n.side-nav-list{\n    scrollbar-width: thin;\n    scrollbar-color: transparent transparent;\n  \n    &::-webkit-scrollbar {\n      width: 1px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: transparent;\n    }\n  }\n\n\n#mex-side-nav .MuiPaper-elevation4{\n    box-shadow: none !important;\n}\n\n#mex-side-nav .MuiDrawer-paperAnchorDockedLeft{\n    border-right: none !important;\n}\n\n/* semanctic step */\n\n.round_panel .steps {\n    border: 1px solid hsla(0,0%,100%,.2);\n}\n.round_panel .step, .round_panel .step:after {\n    background-color: #202125 !important;\n    border: 1px solid #929395;\n    color: #929395;\n}\n\n.round_panel .step .content .description, .round_panel .step .content .title {\n    color:#929395;\n}\n\n.round_panel .step.active .content .description, .round_panel .step.active .content .title {\n    color:#FFF;\n}\n\n.round_panel .steps .step, .round_panel .steps .step.active {\n    border-right: 1px solid hsla(0,0%,100%,.2);\n}\n\n.round_panel .steps .step:after {\n    border-right: 1px solid hsla(0,0%,100%,.2);\n    border-bottom: 1px solid hsla(0,0%,100%,.2);\n}\n\n.round_panel .step.active, .round_panel .step.active:after {\n    background-color: #f080ba !important;\n}\n\n.mex-card {\n    position: relative;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #2c2d34;\n    background-clip: border-box;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n}\n\n/* Legend Role Marker */\n.markBox .mark {\n    color:#FFF;\n    margin-right: 25px;\n    padding: 2px 5px 2px 5px;\n    font-size: 14px;\n    font-weight: 900;\n    border-radius: 5px;\n}\n\n.markBox .mark.markA.markS {\n/*    background-color: rgba(136,221,0,.8); */\n      background-color: rgba(226, 0, 116, 1);\n}\n.markBox .mark.markD.markM {\n    background-color: rgba(255, 247, 2, 0.7);\n}\n.markBox .mark.markD.markC {\n    background-color: rgba(255, 247, 2, 0.5);\n}\n.markBox .mark.markD.markV {\n    background-color: rgba(255, 247, 2, 0.3);\n}\n.markBox .mark.markO.markM {\n    background-color: rgba(204, 236, 255, 0.7);\n}\n.markBox .mark.markO.markC {\n    background-color: rgba(204, 236, 255, 0.5);\n}\n.markBox .mark.markO.markV {\n    background-color: rgba(204, 236, 255, 0.3);\n}\n/* Legend Role Marker */\n\n/* Reg Map */\n.panel_worldmap {\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    border: solid 0 rgba(255,255,255,.125);\n    background-color: rgba(0,0,0,.2);\n}\n.panel_worldmap > div{\n    height: 100%;\n}\n/* Reg Map */\n\n/* Main Header Toolbar */\n.MuiToolbar-regular {\n    min-height: 55px !important;\n}\n\n.MuiToolbar-root>label, .MuiToolbar-root>button, .MuiToolbar-root>button.ui.button {\n    margin-right:20px;\n}\n/* Main Header Toolbar */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
